.onBoardingBar {
  font-weight: 600;
  padding: 1.5rem 2.5rem;
}
